import React, {ReactNode} from 'react'
import {TableRowName} from '../../../../styledComponents/adminPage/Table'
import BusinessScheduleInput from './BusinessScheduleInput/BusinessScheduleInput'
import {TimeTableItem} from './BusinessScheduleItemInterfaces'
import {
    MaxReservationTimeInputForm,
    MaxReservationTimeInputFormPropsWithCallback,
} from './MaxReservationTimeInputForm/MaxReservationTimeInputForm'

import { TableRow, TableCell } from '@mui/material';

interface Props {
    timeTableItems: TimeTableItem[]
    maxReservationTimeInputFormProps: MaxReservationTimeInputFormPropsWithCallback
    onChangeBusinessSchedule: (item: TimeTableItem[]) => void
}

export default class InputForm extends React.Component<Props> {

    constructor(props: Readonly<Props>) {
        super(props)
    }

    render(): ReactNode {
        return (<>
            <TableRow>
                <TableRowName required>最大予約時間</TableRowName>
                <TableCell>
                    <MaxReservationTimeInputForm
                        {...this.props.maxReservationTimeInputFormProps}
                    />
                </TableCell>
            </TableRow>
            <BusinessScheduleInput
                timeTableItems={this.props.timeTableItems}
                onChangeBusinessSchedule={this.props.onChangeBusinessSchedule}
            />
        </>)
    }
}
